import React from 'react';
import { WhitePanelLayout } from '@dom/components';
import Toggler from '../Toggler';
import { Button, Collapse } from 'reactstrap';

import config from '@dom/config';

import './faqs.scss';

function Accordian(props) {
  return (
    <Toggler initialOn={props.isOpen}>
      {({ toggle, on }) => {
        return (
          <div className="flight-acc">
            <Button color="none" onClick={toggle}>
              <span>{props.title}</span>{' '}
              <i className="icon icon-hg-chev-down" />
            </Button>
            <Collapse isOpen={on}>{props.children}</Collapse>
          </div>
        );
      }}
    </Toggler>
  );
}

const Group = props => <div {...props} className="wrapper" />;

const Question = props => <h5 id={props.id}>{props.question}</h5>;

const Answer = props => <p {...props} />;

const ContactHoneyguide = ({ children }) => <a href={`mailto:${config.honeyguideEmail}`} target="_blank" rel="noopener noreferrer nofollow">{children}</a>

const WhatsappHoneyGuide = ({ children }) => <a href={`https://wa.me/${config.honeyguidePhoneNumber}`} target="_blank" rel="noopener noreferrer nofollow">{children}</a>;

export const GuideFAQ = ({ isOpen }) => {
  return (
    <Accordian title="Guide Booking FAQs">
      <Group>
        <Question question="Is there a way I can talk to the guides before booking?" id="talk-to-a-guide"/>
        <Answer>
          Yes. You can contact guides in two ways:<br/>
          1. On Your Own: There are contact numbers, email addresses and links to the social media profiles in each guide’s profile.<br/>
          2. Through HoneyGuide- If you don’t hear back from the guides or need help getting in touch, you can <WhatsappHoneyGuide>message HoneyGuide</WhatsappHoneyGuide> and we will help you connect with the guides directly or pass your queries as per your preference.<br/>
        </Answer>
      </Group> 
      <Group>
        <Question question="Can I get guides from Lukla or Pokhara itself?" />
        <Answer>
          Yes. We have guides based in Lukla, Kathmandu as well as Pokhara. Feel free to use the search filters or simply check the base city of the guide before booking. Hiring a guide directly from Lukla or Pokhara will save you bucks as you don’t need to cover their flights/transportation charge.
        </Answer>
      </Group>
      <Group>
        <Question question="How do I know if the Guide knows about the region I want to trek?" />
        <Answer>
          Please go through the guide’s profile and the experience and expertise region. If the information is insufficient, please send us your query at <ContactHoneyguide>{config.honeyguideEmail}</ContactHoneyguide> and we will help with the coordination.
        </Answer>
      </Group>
      <Group>
        <Question question="I’m not sure about the Guides I want to book?" />
        <Answer>
        If you want a recommendation, you can check the reviews and ratings. For any consultation, kindly <ContactHoneyguide>contact HoneyGuide</ContactHoneyguide>.
        </Answer>
      </Group>
      <Group>
        <Question question="I am not sure about the specific dates yet. What should I do?" id="no-specific-dates"/>
        <Answer>
          It is absolutely okay. Please select the tentative region and dates for our knowledge. We will eventually follow up to get more details after you’ve booked the guides. Slight changes won’t matter.
        </Answer>
      </Group>
      <Group>
        <Question question="Can I customize my trek? Can I change our itinerary and add days during the trek?" />
        <Answer>
        Yes, you can always add or reduce days and discuss changes by talking to your guide as you see fit. You will have to pay the per day wages to the guide in case of additional days.
        </Answer>
      </Group>
      <Group>
        <Question question="Where will I meet the guide?" />
        <Answer>
          Once you have booked a guide, we will connect you with him/her directly. So, it is up to you where you want to meet your guide.
        </Answer>
      </Group>
      <Group>
        <Question question="How will I know if the guide is available for the dates I have requested?" />
        <Answer>
          Once you enter dates and click the search button, you will see a message in a yellow box in the bottom right corner that- the guide you have requested is not available.<br/>
          If you wish to check guide’s availability from their profile page, please enter the ‘Check Availability’ button by entering your dates and you will know.
        </Answer>
      </Group>
      <Group>
        <Question question="How will I know whether or not my booking has been confirmed?" />
        <Answer>
          You will receive a confirmation email about your booking after you have made the payment successfully. In addition, one of the team members from HoneyGuide will also contact you. If you don’t receive any of these within 24 hours, please <ContactHoneyguide>contact us</ContactHoneyguide>.<br/>
          Note: Incase the guide is not available for some reason; you can always request a refund or select another guide.
        </Answer>
      </Group>
      <Group>
        <Question question="I have not received any confirmation email yet. What should I do?" />
        <Answer>
          If you don’t see any email within 24 hours, <ContactHoneyguide>please contact</ContactHoneyguide> HoneyGuide for assistance. [Kindly check the spam folder as well before writing to us]
        </Answer>
      </Group>
      <Group>
        <Question question="What does the Guide’s cost include?" />
        <Answer>
          The Guide cost covers:<br/>
          1. Daily wages of the Guide<br/>
          2. Food and Accommodation Cost for the Guide<br/>
          3. Insurance for the Guide<br/><br/>
          However, the price doesn’t include:<br/>
          1. Any kind of Transportation- Flights or land transportation.<br/>
          2. Tips- Tipping the staff is a conventional practice in Nepal’s trekking Industry. The general tipping practice is minimum 15% of the wages. However, please feel free to tip as per you wish, group size, and level of satisfaction. There is no limit on the higher side.
        </Answer>
      </Group>
      <Group>
        <Question question="Do I need to pay for guide’s lodging and fooding?" />
        <Answer>
          No. The they will manage accommodation and food on their own.
        </Answer>
      </Group>
      <Group>
        <Question question="How much should I tip my Guide?" />
        <Answer>
          Tipping the staff is a conventional practice in Nepal’s trekking Industry. The general tipping practice is minimum 15% of the wages. However, please feel free to tip as per you wish, group size, and level of satisfaction. There is no limit on the higher side
        </Answer>
      </Group>
      <Group>
        <Question question="When should I tip the Guide? And in which currency?" />
        <Answer>
        You can tip the Guide on the final day of the trip. You will have to tip in Nepalese currency. Please make sure you carry extra cash or exchange the money beforehand.
        </Answer>
      </Group>
      <Group>
        <Question question="Who is responsible if anything happens to the Guide during the trails?" />
        <Answer>
          HoneyGuide covers the Insurance of the Guide. In case there is an issue with the guide, you can <ContactHoneyguide>contact HoneyGuide</ContactHoneyguide> and can help with the replacement.
        </Answer>
      </Group>
      <Group>
        <Question question="Will the guide help me with permits and logistics?" />
        <Answer>
          Yes. Guides generally guide you regarding the permits, transportation and logistics. Once you have booked your guide, you can communicate with your guide and get your permits booked beforehand.
        </Answer>
      </Group>
      <Group>
        <Question question="If I have doubts after I talk to the guide, can I change the guide?" />
        <Answer>
          We encourage you to talk to the guide before booking. However, if you need changes, you can <ContactHoneyguide>contact HoneyGuide</ContactHoneyguide> with a valid reason and HoneyGuide will help you find another guide according to your preference.
        </Answer>
      </Group>
      <Group>
        <Question question="What is the HoneyGuide’s Cancellation Policy for Guides?" />
        <Answer>
          HoneyGuide has a policy of full refund within 7 days of booking.<br/>
          After that, certain charges will be deducted as guide compensation on a case by case basis if you cancel.
          However, you have options to change the guide after talking to one if you wish
        </Answer>
      </Group>
      <Group>
        <Question question="What happens if I have to cut my trip short/off in between while trekking?" />
        <Answer>
          In such a case, the amount that you have paid will not be refunded considering the Guides’s time and commitment. However, <ContactHoneyguide> please let us know!</ContactHoneyguide>
        </Answer>
      </Group>
      <Group>
        <Question question="What happens if the guide confirms the trek and cannot lead for any given reason?" />
        <Answer>
          In such cases, you can choose either of the two options:<br/>
          1. Claim full refund.<br/>
          2. Book another guide of similar price range and expertise.<br/>
          Please contact HoneyGuide if you need to claim a refund or book another guide.
        </Answer>
      </Group>
      <Group>
        <Question question="How much time do I need between arrival and trek start?" />
        <Answer>
          If you have selected a guide from Kathmandu, you can arrive a day ahead and meet your Guide. In the case of big groups, trek briefing becomes very important, so it is advised to schedule a fixed time by talking to the Guide for briefing.
        </Answer>
      </Group>
      <Group>
        <Question question="How many trekkers can a single guide lead?" />
        <Answer>
          Generally, a single guide can lead up to 6 people easily. In the case of bigger groups, the group might need an assistant guide to look after the entire group efficiently.
        </Answer>
      </Group>
      <Group>
        <Question question="Why does the rate show higher than the daily wages multiplied?" />
        <Answer>
          When you book a guide, the Insurance cost of Guide worth $30 adds up, which makes the rate look higher.
        </Answer>
      </Group>
    </Accordian>
  );
}

export const PorterGuideFAQ = () => {
  return (
    <>
      <Group>
        <Question question="Who is a Porter-Guide?" />
        <Answer>
        A Porter-Guide is someone who will carry your bags and show you the path while in the trails.
          <br/> - Basic Guiding and will Carry upto 13 kgs.
          <br/> - Mostly Locals. Will join you from the trailhead. (e.g. Lukla, Pokhara)
          <br/> - Limited Communication and First-Aid Skills.
        </Answer>
      </Group>
      <Group>
        <Question question="How much weight will my Porter-Guide carry?" />
        <Answer>
          Porter Guides carry up to 13 kgs weight.
        </Answer>
      </Group>
      <Group>
        <Question question="How will the booking work?" />
        <Answer>
          Step 1: After you request a Porter-Guide, HoneyGuide will contact you and get details about your itinerary, preferences and flight/transport timings.<br/>
          Step 2: HoneyGuide will contact the available porters and communicate your booking details to the confirmed porter-guide.<br/>
          Step 3: We will send you the guide’s information with relevant contact numbers and confirmed meeting place and vise versa.<br/>
          Step 4: On your flight/ transport date, the porter guide will meet you at the decided place.<br/>
        </Answer>
      </Group>
      <Group>
        <Question question="Where will I meet my Porter-Guide?" />
        <Answer>
          You will meet your Porter-Guide in the trailhead.<br/>
          - For Everest: He/She will be waiting for you at Lukla Airport as per your flight timing.<br/>
          - For Annapurnas: He/She could meet you at your hotel/ Airport according to your preference.<br/>
        </Answer>
      </Group>
      <Group>
        <Question question="What services are covered in the price?" />
        <Answer>
          The cost covers:<br/>
          1. Daily wages of the Porter-Guide<br/>
          2. Food and Accommodation Cost for the Porter-Guide<br/>
          3. Insurance for the Porter-Guide<br/>
          4. Replacement Confirmation in case anything happens to the guide in the trail.<br/>
          5. Pre-trek communication between trekker and Guide.<br/>
          <br/>
          However, the price doesn’t include:<br/>
          1. Local Transportation if necessary.<br/>
          2. Tips- Tipping the staff is a conventional practice in Nepal’s trekking Industry. The general tipping practice is minimum 15% of the wages. However, please feel free to tip as per you wish, group size, and level of satisfaction. There is no limit on the higher side.
        </Answer>
      </Group>
      <Group>
        <Question question="Do I have to pay for the Porter-Guide’s Accommodation and food?" />
        <Answer>
          No. They will manage accommodation and food on their own.
        </Answer>
      </Group>
      <Group>
        <Question question="What if I want to cancel a booking?" />
        <Answer>
          HoneyGuide has a policy of full refund within 7 days of booking.
          After that, certain charges will be deducted as guide compensation on a case by case basis if you cancel.
          However, you have options to change the guide after talking to one if you wish. 
        </Answer>
      </Group>
      <Group>
        <Question question="Who is responsible if my porter guide falls sick/ leaves in between the trek?" />
        <Answer>
          HoneyGuide will be responsible for finding a replacement if any issue happens with the porter-Guide in the trail. In case of any problem, please <ContactHoneyguide>Contact HoneyGuide</ContactHoneyguide>.
        </Answer>
      </Group>
      <Group>
        <Question question="What happens if I have to cut my trip short/off in between while trekking?" />
        <Answer>
          In such a case, the amount that you have paid will not be refunded considering the Porter-Guides’s time and commitment. However, <ContactHoneyguide>please let us know!</ContactHoneyguide>
        </Answer>
      </Group>
      <Group>
        <Question question="How will I communicate my requirements to the Porter-Guide?" />
        <Answer>
        If you have any preference or specific requirement that you wish to communicate to the Porter-Guide, please write to HoneyGuide. We will pass the information.
        </Answer>
      </Group>
      <Group>
        <Question question="How much should I tip my Porter-Guide?" />
        <Answer>
          Tipping the staff is a conventional practice in Nepal’s trekking Industry. The general tipping practice is minimum 15% of the wages. However, please feel free to tip as per you wish, group size, and level of satisfaction. There is no limit on the higher side.
        </Answer>
      </Group>
      <Group>
        <Question question="When should I tip the Porter Guide? And in which currency?" />
        <Answer>
          You can tip the Porter-Guide on the final day of the trip. You will have to tip in Nepalese Currency. Please make sure you carry extra cash or exchange the money beforehand. 
        </Answer>
      </Group>
      <Group>
        <Question question="How should I pack so the Porter-Guide can carry my bag? What kind of bag should I carry?" />
        <Answer>
          A Porter-Guide will carry your backpack. It is, however, easier if you have a duffel bag. If need be, they will tie multiple bags together. Please make sure you carry your valuable goods and day time essentials with you. Also, having a rain cover is important
        </Answer>
      </Group>
      <Group>
        <Question question="Can HoneyGuide book my Flight/ Transportation?" />
        <Answer>
          Yes, you can book flights as well as transportation easily at HoneyGuide’s website. <ContactHoneyguide>Contact us</ContactHoneyguide> if you need help!
        </Answer>
      </Group>
      <Group>
        <Question question="Will the Porter-Guide help me book my permits?" />
        <Answer>
          As you will meet your porter-Guide in the starting point of your trek, your porter-guide can help you with permits only in trekking areas that don’t require you to buy permits beforehand like Everest Base Camp Trek. Please do your part of the research. Also, make sure you tip a little better for the service.
        </Answer>
      </Group>
    </>
  );
}

const FAQs = () => {
  return (
    <>
      <WhitePanelLayout title="Frequently Asked Questions (FAQs)" >
        <GuideFAQ isOpen={true} />
        <Accordian title="Porter-Guide FAQs">
          <PorterGuideFAQ />
        </Accordian>
      </WhitePanelLayout>
    </>
  )
};

export default FAQs;
